module.exports = __webpack_public_path__ + "img/cat4.17142a3b.svg";